import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { jiekuanApi } from "../../api/jiekuan-api";
import { newsApi } from "../../api/news-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { FieldTimeOutlined } from "@ant-design/icons";

export default function JieKuan() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const uid = localStorage.getItem("uid");
  const [loading,setLoading] = useState(false)

  //申请
  const add = async (sendData) => {
    setLoading(true)
    const data = await jiekuanApi.add({ ...sendData, uid });
    Toast.show({ 
      content: data.msg,
      duration:1000,
      afterClose(){
        setLoading(false)
        navigate("/mycenter");
      }
    });
  };
  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100 revert-style">
      <AcendexLayout
        theme="light"
        hideBottomBar
        mobileTopBarTitle={translate(getText("借貸"))}
        pcTopBarTitle={translate(getText("借貸"))}
        topBarRightContent={
          <button
            className="text-neutral-400 hover:text-primary-light focus:outline-none transition-colors"
            onClick={() => navigate("/jiekuanlist")}
          >
            <FieldTimeOutlined className="text-xl" />
          </button>
        }
      >
        <CenterPage add={add} loading={loading} />
      </AcendexLayout>
    </div>
  );
}
